import React from "react";
import { SurveyPanel } from "../../components/survey/SurveyPanel";

export const SurveyScreen = () => {
  return <SurveyPanel onSkip={() => {}} />;
};
    